<template>
  <TheHeader />
  <button class="mobile-nav-toggle" @click="navOpen = !navOpen">
    {{ navOpen ? `Menü ausblenden (${currentMenuLabel})` : `Menü anzeigen (${currentMenuLabel})` }}
  </button>
  <nav :class="{ 'mobile-hidden': !navOpen }">
    <button @click="Contact">Kontakt</button>
    <button @click="Logout">Logout</button>
  </nav>
  <main class="view">
    <keep-alive>
      <TheSchedule
        v-if="!togglecomp"
        :call="state.call"
        @update="Update"
        @edit="Edit"
      />
    </keep-alive>
    <TheScheduleEdit v-if="togglecomp" :scheduleid="scheduleid" @edit="Edit" />
  </main>
  <TheFooter />
</template>
  
<script setup>
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { computed, ref, reactive } from "vue";
import TheSchedule from "@/components/TheSchedule.vue";
import TheScheduleEdit from "@/components/TheScheduleEdit.vue";
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
const store = useStore();
const router = useRouter();
const navOpen = ref(false);
const currentMenuLabel = computed(() => "Ansicht");
function Logout() {
  store.dispatch("auth/logout").then(router.push("/"));
}
function Contact() {
  window.open("https://www.priokom.de/kontakt/anfrage", "_contact");
}

let togglecomp = ref(false);
let scheduleid = ref(0);
const state = reactive({ call: false });

function Update() {
  state.call = false;
}

function Edit(schedule) {
  scheduleid.value = schedule;
  togglecomp.value = !togglecomp.value;
  if (!togglecomp.value) state.call = true;
}
</script>
  
<style scoped>
.view {
  padding-bottom: 96px;
}
button {
  width: 20%;
}

@media (max-width: 1023px) {
  .view {
    padding-bottom: 170px;
  }
}

@media (min-width: 421px) {
  .mobile-nav-toggle {
    display: none;
  }
}
</style>
  
